// Regras do catálogo que a API aplica desde a BBF-98 e a BBF-134 (app-funcionalidades, migrations
// 0060 e 0061). A tela repete as mesmas para avisar antes de salvar; quem decide é a API.

export const CHAVE_REGEX = /^[a-z0-9]+([._-][a-z0-9]+)*$/;
export const CHAVE_TAMANHO = 120;

export const TIPOS_FUNCIONALIDADE = [
    {value: 'LEITURA', label: 'Leitura'},
    {value: 'ESCRITA', label: 'Escrita'},
];

export const ALERTA_LEITURA_COM_ESCRITA = 'LEITURA_COM_METODO_DE_ESCRITA';
export const ALERTA_ESCRITA_SO_GET = 'ESCRITA_SO_COM_GET';

export const ALERTAS = {
    [ALERTA_LEITURA_COM_ESCRITA]: {
        rotulo: (metodo) => `Leitura via ${metodo || 'POST'}`,
        explicacao: 'Declarada como leitura, mas usa método de escrita. Está certo quando a chamada só consulta, como a busca por CPF via POST: em "somente consulta" ela continua liberada.',
    },
    [ALERTA_ESCRITA_SO_GET]: {
        rotulo: () => 'Escrita só com GET',
        explicacao: 'Declarada como escrita, mas só tem GET. Confira se não deveria ser leitura: em "somente consulta" ela fica bloqueada.',
    },
};

export const slug = (texto) => (texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
    .replace(/-+$/g, '');

// Chave sugerida a partir do nome e de quem contém o item, como a migration 0061 preencheu:
// módulo `<chave do sistema>.<nome>` e funcionalidade `<chave do módulo>.<nome>`.
export const sugerirChave = (nome, chavePai) => {
    const base = slug(nome);
    if (!base) return '';
    return (chavePai ? `${chavePai}.${base}` : base).slice(0, 110).replace(/[._-]+$/g, '');
};

export const validarChave = (chave) => {
    const valor = (chave || '').trim();
    if (!valor) return 'Informe a chave.';
    if (valor.length > CHAVE_TAMANHO) return `A chave tem no máximo ${CHAVE_TAMANHO} caracteres.`;
    if (!CHAVE_REGEX.test(valor)) return 'A chave usa letras minúsculas sem acento, números e os separadores ".", "_" ou "-".';
    return '';
};

// O identity casa `{qualquer_nome}` com `[^/]+`: `/x/{id}` e `/x/{project_id}` são o mesmo recurso.
export const caminhoNormalizado = (endpoint) => (endpoint || '').trim().replace(/\{[^/}]*\}/g, '{}');

export const chaveDoRecurso = (recurso) => `${(recurso.metodo || '').toUpperCase()} ${caminhoNormalizado(recurso.endpoint)}`;
